import { InstitutionFilter } from "@bitwarden/web-vault/app/models/types/filter.types";
import { UserStoreService } from "@bitwarden/web-vault/app/services/store/user/user.store.service";
import { inject, Injectable } from "@angular/core";
import { FilterControlType } from "@bitwarden/web-vault/app/services/store/calculation-base/controls/filter.control";
import { CountryView } from "@bitwarden/web-vault/app/models/view/country/country.view";
import { ViewsFilterAccountHelper } from "@bitwarden/web-vault/app/gloss/views/views-control/views-customize/views.filter.helper.accounts";

@Injectable({
  providedIn: "root",
})
export class ViewsFilterInstitutionHelper {
  private userStore = inject(UserStoreService);
  private accountFilterHelper = inject(ViewsFilterAccountHelper);

  getFilter(
    options: FilterControlType,
    selected: FilterControlType,
    countryView: CountryView,
  ): Map<string, InstitutionFilter> {
    return this.institutionFilterForCountry(options, selected, countryView);
  }

  private institutionFilterForCountry(
    options: FilterControlType,
    selected: FilterControlType,
    countryView: CountryView,
  ) {
    const isSelectedCountry = selected.countries.includes(countryView.code);
    const institutionFilterMap: Map<string, InstitutionFilter> = new Map();
    const countryInstitutions = this.institutionsOfCountry(options, countryView);

    for (const institutionView of countryInstitutions) {
      const isSelectedInsto = selected.institutions.includes(institutionView.id);
      const instoFilter: InstitutionFilter = {
        view: institutionView,
        childFilter: this.accountFilterHelper.getFilter(options, selected, institutionView),
        isSelected: isSelectedCountry && isSelectedInsto,
        isDisabled: !isSelectedCountry,
      };

      institutionFilterMap.set(institutionView.id, instoFilter);
    }
    return institutionFilterMap;
  }

  private institutionsOfCountry(options: FilterControlType, countryView: CountryView) {
    const institutionViews = this.userStore.institutions.institutionViews();
    const accountViews = this.userStore.enrichAccounts.collection();
    return institutionViews.filter((institution) => {
      const isInOptions = options.institutions.includes(institution.id);
      const isCountry = institution.swift.countryCode === countryView.code;
      const hasAccounts = accountViews.some(
        (av) => av.institutionLink.institutionId === institution.id,
      );
      return isInOptions && isCountry && hasAccounts;
    });
  }
}
